<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="select" label="素材分类" name="type_id" options="MEDIA_CATALOG_TYPE_ID"></c-form-item>
                    <c-form-item type="input" label="素材内容" name="content"></c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_media_catalog_edit" color="sys" @click="navigateTo(`/media/catalog/add`)">新增素材</c-button>
                <c-button power="b_media_catalog_edit" color="sys"  @click="openTypeManage()">素材分类管理</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="素材分类"
                        name="type_name"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="素材内容"
                        name="content"
                        width="120"
                >
                </c-table-column>

                <c-table-column
                        label="素材图片"
                        name="advert_img"
                        width="300"
                >
                    <template v-slot="{data}">
                        <div  class="flex-center-cross">
                            <c-image v-if="data.img_list" v-for="(medias, j) in data.img_list" :key="j" class="img" :src="medias" size="40" preview></c-image>
                            <span v-else>--</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="素材视频"
                        name="advert_img"
                        width="100"
                >
                    <template v-slot="{data}">
                        <div  class="flex-center-cross">
                            <c-image v-if="data.video_url" class="img" :src="data.video_url" size="40" preview></c-image>
                            <span v-else>--</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                    label="关联商品"
                    name="product_id"
                    width="120"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_id > 0 && data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else-if="data.product_id > 0 && !data.product_itemnumber" :image="data.product_img_url" :name="data.product_name"></product-info>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span style="color:darkgreen" v-if="data.state==2">启用</span>
                        <span style="color:red" v-if="data.state==1">禁用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建日期"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        power="b_media_catalog_edit"
                        @sort="sortHandle"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_media_catalog_edit" @click="navigateTo(`/media/catalog/edit/${data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_media_catalog_edit" @click="del(data)">删除</c-table-button>
                        <c-table-button power="b_media_catalog_edit" v-if="data.state == 1" @click="updateState(2, data)">{{ '启用' }}</c-table-button>
                        <c-table-button power="b_media_catalog_edit" v-if="data.state == 2" @click="updateState(1, data)">{{ '禁用' }}</c-table-button>
                    </template>
                </c-table-column>
            </c-table>


        </module>
        <c-dialog ref="typeDialog" title="素材分类管理" width="800" :button="false">
            <m-operate>
                <c-button color="sys"  @click="openAddTypeDia" power="b_media_catalog_edit">新增分类</c-button>
            </m-operate>

            <c-table ref="typeTable" height="500">
                <c-table-column
                        label="分类名称"
                        name="name"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortTypeHandle"
                        width="120"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="170"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_media_catalog_edit" @click="openEditTypeDia(data)">编辑</c-table-button>
                        <c-table-button power="b_media_catalog_edit" @click="deleteTypeHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="typeEdit" :title="editTypeState ? '编辑素材分类' : '新增素材分类'" width="600" @resolve="editTypeHandle">
            <c-form ref="typeForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="分类名称" name="name" required></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
import {mapState} from "vuex";
import productInfo from "@/components/public/product_info.vue";

export default {
    name: 'm_media_catalog',
    components: {productInfo},

    data() {
        return {
            editState: false,
            editTypeState:false
        }
    },

    computed: {
        ...mapState(['systemConfig'])
    },

    watch: {
    },

    mounted() {
        this.$refs.search.search();

        this.$bus.$on('mediaCatalog.update', page => {
            this.$refs.table.update(page);
        });
    },

    methods: {
        searchHandle(data) {
            this.$refs.table.load({
                url: '/media/catalog/list',
                data
            });
        },

        sortHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData = {};
            if (type == 'top' || type == 'bottom') {
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if (type == 'up') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if (type == 'down') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/media/catalog/sort',
                data: submitData,
                loading: true,
                success: data => {
                    if (type == 'top' || type == 'bottom') {
                        this.$refs.table.update();
                    } else {
                        next();
                    }
                }
            });
        },

        del(val) {
            this.$confirm({
                text: '确定要删除当前素材？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/media/catalog/remove',
                        data: {id: val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        updateState(type, val) {
            this.$confirm({
                text: '确定要' + (type == 2 ? '启用' : '禁用') + '素材吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/media/catalog/update_state',
                        data: {id: val.id, state: type},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },
        openTypeManage(){
            this.$refs.typeDialog.open();
            this.$refs.typeTable.load({
                url: '/media/catalog/type/list',
                dataFormatter: data => {
                    return data;
                }
            });
        },
        openAddTypeDia(){
            this.editTypeState = false;
            this.$refs.typeEdit.open();
            this.$refs.typeForm.clear();
        },

        sortTypeHandle(row, type, next) {
            this.request({
                url: '/media/catalog/type/sort',
                data: {
                    id: row.data.id,
                    parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
                    type: ['top', 'bottom'].includes(type) ? type : '',
                    id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                    id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                },
                loading: true,
                success: data => {
                    this.$refs.typeTable.update();
                    // next();
                }
            });
        },

        openEditTypeDia(val){
            this.editTypeState = true;
            this.$refs.typeForm.set(val);
            this.$refs.typeEdit.open();
        },
        
        deleteTypeHandle(val){
            this.$confirm({
                text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/media/catalog/type/del',
                        data: {id:val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.typeTable.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        editTypeHandle(stop) {
            stop();
            this.$refs.typeForm.submit({
                url: this.editTypeState ? '/media/catalog/type/update' :'/media/catalog/type/add',
                rule: {
                    name: '请填写分类名称'
                },
                success: () => {
                    this.$refs.typeTable.update();
                    this.$refs.typeEdit.close();
                }
            });
        }
    }
}
</script>